// import api from '@/api'
import { jsFn } from '@/utils/jsFn'
const KEEPSTORAGE = 'KEEPSTORAGE'
const SETACTIVITY = 'SETACTIVITY'

export default {
    namespaced: true,
    state: {
        event4: {
            aitext: {
                base: 'AITEXT',
                extend: 'AITEXT-E2'
            },
            soklite: {
                base: 'SOKLITE',
                extend: 'SOKLITE-E2'
            }
        }
    },
    getters: {
        event4: (state) => state.event4,
    },
    mutations: {
        [KEEPSTORAGE](state, data) {
            let keys = Object.keys(data)
            keys.forEach(key => {
                state[key] = data[key]
            })
        },
        [SETACTIVITY](state, data) {
            let keys = Object.keys(data.detail)
            keys.forEach(key => {
                state[data.name][key] = data.detail[key]
            })
        }
    },
    actions: {
        /** 
         * NOTE: 維持 vuex state 的資訊
        */
        keepState(context) {
            if(!jsFn.IsEmpty(localStorage.getItem('activityData'))) {
                let data = JSON.parse(decodeURIComponent(localStorage.getItem('activityData'),'utf-8'))
                context.commit(KEEPSTORAGE, data)
            }
        },
        /** 
        * NOTE: 儲存現在 state 的資訊
        */
        saveState(context) {
            localStorage.setItem('activityData', encodeURIComponent(JSON.stringify(context.state), 'utf-8'))
        }
    }
}
